import { useDispatch } from "react-redux";
import { Text, Button, Col, FlexboxGrid, Row } from "rsuite";
import React, { useCallback } from "react";
import dayjs from "dayjs";
import { setTaxSteps } from "../../../store/slices/flow/flowThunks";
import usePlaceNavigate from "../../../hooks/usePlaceNavigate";
import { updateTaxFlowData } from "../../../store/slices/tax/taxSlice";

const UnreportedLicensePeriod = ({ periodStartDate, periodEndDate, periodLabel, address, applicationNumber, licenseNumber, totPayable }) => {
  const placeNavigate = usePlaceNavigate();
  const dispatch = useDispatch();

  const onFlowStepsMapped = (path) => {
    placeNavigate(`/${path}`);
  }

  const initiatePayTax = useCallback(() => {
    if (totPayable) {
      const selectedData = [
        {
          startDate: periodStartDate,
          endDate: periodEndDate,
          selected: true,
          year: dayjs(periodStartDate).year(),
          label: periodLabel,
          licenses: [
            {
              address: address,
              selected: true,
              license: licenseNumber
            }
          ]
        }
      ];

      dispatch(updateTaxFlowData({ selectedLicenses: selectedData }));
      dispatch(setTaxSteps(onFlowStepsMapped, true, `/single-permit/${applicationNumber}`));
    }

  }, [periodStartDate, periodEndDate, periodLabel, totPayable]);

  return (
    <FlexboxGrid role="grid" align="middle" className="reporting-history-item-header unreported-history-accordion-header" fluid>
      <FlexboxGrid.Item as={Row} colspan={24}>
        <Col xs={12} md={8} className="pb-lg-lower-8">
          <Text className="text-large text-bold">{periodLabel}</Text>
        </Col>
      {
        totPayable && (
          <>
            <Col xs={12} md={8} className="pb-lg-lower-8">
              <Text style={{ textAlign: 'center' }} className="sm-text-right">Not yet reported</Text>
            </Col>
            <Col xs={24} md={8} style={{ textAlign: 'right' }}>
              <Button onClick={() => { initiatePayTax(); }} className="sm-100-percent btn-tertiary-outline">Pay Tax</Button>
            </Col>
          </>
        )
      }
      </FlexboxGrid.Item>
    </FlexboxGrid>
  );
};

export default UnreportedLicensePeriod; 
